import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import busLists from './reducers/busReducer';
import paymentVerification from './reducers/paymentVerificationReducer';
import approval from './reducers/approvalReducer';

const middleware = applyMiddleware(thunk);

const combinedReducer = combineReducers({
  busLists,
  paymentVerification,
  approval,
});

export const store = createStore(
  combinedReducer,
  composeWithDevTools(middleware)
);
